import { createSlice } from '@reduxjs/toolkit';
import {
	getMeasurementDetailListQuery,
	addNewMeasurementDetail,
	updateMeasurementDetail,
	deleteMeasurementDetail,
} from './thunk';

const initialState = {
	data: [],
	isListLoading: false,
	isListLoaded: false,
	error: null,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const MeasurementDetailSlice = createSlice({
	name: 'MeasurementDetail',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		// List query
		builder
			.addCase(getMeasurementDetailListQuery.pending, state => {
				state.isListLoading = true;
				state.isListLoaded = false;
				state.error = null;
			})
			.addCase(getMeasurementDetailListQuery.fulfilled, (state, action) => {
				state.isListLoading = false;
				state.isListLoaded = true;
				state.data = action.payload?.data || action.payload || [];
			})
			.addCase(getMeasurementDetailListQuery.rejected, (state, action) => {
				state.isListLoading = false;
				state.error = action.error.message;
			});

		// Add
		builder
			.addCase(addNewMeasurementDetail.pending, state => {
				state.isAdding = true;
				state.isAdded = false;
				state.isAddError = false;
			})
			.addCase(addNewMeasurementDetail.fulfilled, (state, action) => {
				state.isAdding = false;
				state.isAdded = true;
				state.isAddError = false;
				state.requireCloseModal = true;
			})
			.addCase(addNewMeasurementDetail.rejected, (state, action) => {
				state.isAdding = false;
				state.isAddError = true;
			});

		// Update
		builder
			.addCase(updateMeasurementDetail.pending, state => {
				state.isUpdating = true;
				state.isUpdated = false;
				state.isUpdateError = false;
			})
			.addCase(updateMeasurementDetail.fulfilled, (state, action) => {
				state.isUpdating = false;
				state.isUpdated = true;
				state.isUpdateError = false;
				state.requireCloseModal = true;
			})
			.addCase(updateMeasurementDetail.rejected, (state, action) => {
				state.isUpdating = false;
				state.isUpdateError = true;
			});

		// Delete
		builder
			.addCase(deleteMeasurementDetail.pending, state => {
				state.isDeleting = true;
				state.isDeleted = false;
				state.isDeleteError = false;
			})
			.addCase(deleteMeasurementDetail.fulfilled, (state, action) => {
				state.isDeleting = false;
				state.isDeleted = true;
				state.isDeleteError = false;
				state.requireCloseModal = true;
			})
			.addCase(deleteMeasurementDetail.rejected, (state, action) => {
				state.isDeleting = false;
				state.isDeleteError = true;
			});
	},
});

export const { setRequireCloseModal } = MeasurementDetailSlice.actions;

export default MeasurementDetailSlice.reducer;
